import { CandidateStatus } from "../../_enums/candidateStatus.enum";
import { SignatureType } from "../../_enums/signatureType.enum";

export interface MarketingSettingsInterface {
	verifiedDomain: boolean;
	content?: string;
	json?: string;
}

export interface MarketingSingleSendErrorInterface {
	nameError?: string;
	recipientsError?: string;
	templateError?: string;
	documentsError?;
	subjectError?: string;
	scheduleTimeError?: string;
}

export type MarketingRecipientType = {
	_id: string;
	contactId: string;
	email: string;
	forename: string;
	lea?: string;
	role: number;
	roleOther?: string;
	surname: string;
	telephone: string;
	recordType?: MarketingRecipientSearchType;
	decisionMaker?: boolean;
};

type TemplateRecordType = {
	name: string;
};

export interface MarketingSingleSendsInterface {
	_id: string;
	createdAt: string;
	name: string;
	recipients: MarketingRecipientType[] | [];
	templateRecord: TemplateRecordType;
	templateName?: string;
	updatedAt: string;
	createdBy?: string;
	scheduleDateTime?: string;
	marketingSent?: boolean;
	marketingCancelled?: boolean;
}

export enum MarketingStatusFilters {
	Scheduled = "Scheduled",
	Sent = "Sent",
	Cancelled = "Cancelled",
}

export interface MarketingSuppressionInterface {
	_id: string;
	email: string;
}

export interface MarketingSingleSendInterface extends MarketingSingleSendErrorInterface {
	_id?: string;
	name: string;
	recipients?: MarketingRecipientType[] | [];
	template: string;
	documents?: string[] | [];
	subject: string;
	category: string;
	attachments?: IAttachmentData[] | [];
	candidates?: string[] | [];
	createdAt?: string;
	sender?: string;
	scheduleDate?: string;
	scheduleTime?: string;
	marketingSent?: boolean;
	marketingCancelled?: boolean;
	signature?: SignatureType;
}

export interface MarketingTemplateErrorInterface {
	nameError?: string;
	categoryError?: string;
	emailError?: string;
}

export interface MarketingTemplateInterface extends MarketingTemplateErrorInterface {
	_id?: string;
	name: string;
	category: string;
	email?: string;
	json: string;
	template: string;
	templateContent: string;
	content: string;
	signature?: SignatureType;
	createdBy?: string;
	updatedBy?: string;
	campaignSpecific?: boolean;
}

export interface MarketingSingleSendRecipientSearchInterface extends MarketingRecipientType {
	searchTypeClient?: boolean;
	type?: string;
	mobile?: string;
	postcode?: string;
	subject?: string;
	county?: string;
	status?: CandidateStatus | null;
	sector?: string;
	lea?: string;
	recordType?: MarketingRecipientSearchType;
	recordId?: string;
}

export interface IAttachmentData {
	content: string;
	filename: string;
	type?: string;
	disposition?: string;
	contentId?: string;
}

export enum MarketingRecipientSearchType {
	client = 1,
	candidate = 2,
}

export interface MailerSingleSendInterface {
	name?: string;
	subject?: string;
	content: string;
	type: "email" | "sms";
	text?: string;
	signature?: SignatureType;
}

export interface MarketingSuppressionInterface {
	email: string;
	_id: string;
	type: "candidate" | "client";
}

export interface MarketingSubscriptionData {
	subscribed?: boolean;
	business?: string;
}
